import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import TabPane from 'antd/es/tabs/TabPane';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { useForm } from 'antd/lib/form/Form';
import DF from 'DisplayFramework';
import ParRateList from './ParRate/ParRate';
import ParTaxeList from './ParTaxe/ParTaxe';
import ProductsList from 'pages/ProductSFS/ProductsList';
import { useParams } from 'react-router-dom';
import ParRuleList from './ParRule/ParRule';
import ParRateFormulasList from './ParRateFormulas/ParRateFormulas';
import ParRateFormulasDetails from './ParRateFormulas/ParRateFormulasDetails';
import Bonus from './Bonus/Bonus';
import ParRateFormulas from './ParRateFormulas/ParRateFormulas';
import ProductFamilyList from './ParProduct/ProductsFamily';
import { useNavigate, useLocation } from 'react-router-dom';
import AnomalyManagement from './AnomalyManagement';

export type ConfigTabsProps = {};

// eslint-disable-next-line no-empty-pattern
const ConfigTabs = ({ }: ConfigTabsProps) => {
  const [form] = useForm();
  let { id, tptype } = useParams<{


    id: string;
    tptype: 'CONC' | 'PM' | 'SPM' | '';
  }>();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState(() => {
    const params = new URLSearchParams(location.search);
    return params.get('tab') || '1';
  });


  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setActiveKey(params.get('tab') || '1');
  }, [location.search]);

  const [color, setColor] = useState<string>();

  useEffect(() => {
    console.log('___tptype', tptype);

    if (tptype === 'CONC') {
      setColor('green');
    } else if (tptype === 'PM') {
      setColor('duck-blue');
    } else if (tptype === 'SPM') {
      setColor('blue');
    } else {
      setColor('purple');
    }
  }, [tptype]);

  return (
    // <DF.Provider pagcode="configsfs">
    <DF.Provider pagcode="parcontrol">
      <Tabs
        className="tabs-border-top"
        activeKey={activeKey}
        onChange={(key) => {
          setActiveKey(key);
          navigate(`?tab=${key}`);
        }}
      >

        <TabPane tab={<GetLabel label="parproductfamily" />} key="1"className="font-size-15">
          <ProductFamilyList color={color ?? ''} />
        </TabPane>
        <TabPane tab={<GetLabel label="paroffer" />} key="2" className="font-size-15">
          <ProductsList />
        </TabPane>
        <TabPane tab={<GetLabel label="parrate" />} key="3" className="font-size-15">
          <ParRateList color={color ?? ''} />
        </TabPane>
        <TabPane tab={<GetLabel label="parrateformulas" />} key="4"className="font-size-15">
          <ParRateFormulas color={color ?? ''} />
        </TabPane>

        <TabPane tab={<GetLabel label="partaxe" />} key="5"className="font-size-15">
          <ParTaxeList color={color ?? ''} />
        </TabPane>

        <TabPane tab={<GetLabel label="parbonus" />} key="6"className="font-size-15">
          <Bonus color={color ?? ''} />
        </TabPane>

        <TabPane tab={<GetLabel label="parrule" />} key="7"className="font-size-15">
          <ParRuleList color={color ?? ''} />
        </TabPane>
         <TabPane tab={<GetLabel label="paranomaly" />} key="8"className="font-size-15">
          <AnomalyManagement color={color ?? ''} />
        </TabPane>
      </Tabs>
    </DF.Provider>
  );
};

export default ConfigTabs;
